module.exports = __webpack_public_path__ + "static/img/login.935f600c.png";